import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import DescriptionText from 'Routes/Cognition/utils/DescriptionText';
import { formatPartialDate } from 'Utility/date';

const SDMT = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id="cognition.sdmt.sdmtLong" />}
      newButton={
        <DocumentCreationButton
          name="sdmt"
          text="cognition.sdmt.newSdmt"
          onClick={startEdit({}, 'sdmt')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
      headerInfoText={<DescriptionText type={'sdmt'} />}
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id="general.date" />
            </Item>
            <Item xs={2}>
              <FormattedMessage id="cognition.sdmt.testType" />
            </Item>
            <Item xs={2}>
              <FormattedMessage id="cognition.sdmt.correctAnswers" />
            </Item>
            <Item xs={2}>
              <FormattedMessage id="cognition.sdmt.allAnswers" />
            </Item>
          </>
        }
        contentFormat={(d): React.JSX.Element => (
          <>
            <Item xs={2}>{formatPartialDate(d.date ?? undefined)}</Item>
            <Item xs={2}>{d.testType ? <FormattedMessage id={`cognition.sdmt.${d.testType}`} /> : '-'}</Item>
            <Item xs={2}>{d.correctAnswers ?? '-'}</Item>
            <Item xs={2}>{d.allAnswers ?? '-'}</Item>
            <Item xs={1}>&nbsp;</Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} view={view} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'sdmt'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default SDMT;
